import { render } from "./StatisticsBody.vue?vue&type=template&id=483c3b51"
import script from "./StatisticsBody.vue?vue&type=script&lang=js"
export * from "./StatisticsBody.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/statistics/main.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__